const SANCTIONED_DIAL_CODES = [
  '7', // Russia and Kazakhstan (+7 shared code)
  '53', // Cuba
  '58', // Venezuela
  '98', // Iran
  '375', // Belarus
  '380', // Ukraine
  '850', // North Korea
  '963', // Syria
];

export default SANCTIONED_DIAL_CODES;
